import { render, staticRenderFns } from "./EmailAuth.vue?vue&type=template&id=38ed8bf2&"
import script from "./EmailAuth.vue?vue&type=script&lang=js&"
export * from "./EmailAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports